import React from 'react';
import bem from 'utils/bem';
import Text from 'components/Text';
import FormikRadioField from 'forms/fields/RadioField/FormikRadioField';
import './index.sass'
import { useFormikContext } from 'formik';

const { cnBlock, el } = bem('payment-field');

export default ( { className } ) => {

    const { values: { paymentSystem } } = useFormikContext()

    return (
        <div className={ cnBlock(className) }>
            <div className={ el( 'radio-option', 'bank-name', { selected: paymentSystem === 'A' } ) }>
                <FormikRadioField
                    name={'paymentSystem'}
                    text={ 'Банковская карта' }
                    comment={ 'Оплата картой Visa, Mastercard, Мир через Альфа-банк' }
                    value={'A'}
                />
            </div>
            <div className={ el( 'radio-option', 'bank-name', { selected: paymentSystem === 'Y' } ) }>
                <FormikRadioField
                    name={'paymentSystem'}
                    text={ 'Ю.KASSA' }
                    comment={ 'Оплата картой Visa, Mastercard, Мир через Ю.KASSA' }
                    value={'Y'}
                />
            </div>
        </div>
    )
}
